import * as NavActions from '../../../store/shipments/nav/shipments.nav.actions';
import { baseReducer as BaseReducer } from '../../../store/core/base-reducer';

import * as Actions from './returns.selected-returns.actions';

const initialState = {
  selectedReturnIds: [],
};

const returnToInitialState = () => initialState;

const actionHandlerMap = {
  [Actions.SET_SELECTED_RETURNS]: (state, { selectedReturnIds }) => {
    return {
      ...state,
      selectedReturnIds,
    };
  },
  [NavActions.SHIPMENTS_CHANGE_VIEW]: returnToInitialState,
};

export const ConnectedActionHandlerMap = BaseReducer(initialState, actionHandlerMap);

export { namespace } from './returns.selected-returns.reducer.metadata';
